var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/content/add_circle_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.0001C2 6.48006 6.48 2.00006 12 2.00006C17.52 2.00006 22 6.48006 22 12.0001C22 17.5201 17.52 22.0001 12 22.0001C6.48 22.0001 2 17.5201 2 12.0001ZM13 13.0001H17V11.0001H13V7.00006H11V11.0001H7V13.0001H11V17.0001H13V13.0001Z",
    fill: "#FB263B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.a9f43fe4460d237c24805010071ca5ff.svg";
export { ForwardRef as ReactComponent };